import { render } from "./TronBlocks.vue?vue&type=template&id=7ab47231&scoped=true"
import script from "./TronBlocks.vue?vue&type=script&lang=js"
export * from "./TronBlocks.vue?vue&type=script&lang=js"

import "./TronBlocks.vue?vue&type=style&index=0&id=7ab47231&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ab47231"]])

export default __exports__